module.exports = __webpack_public_path__ + "img/20.551cd30f.jpg";